import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Header, Icon, Segment } from 'semantic-ui-react';
import styled from 'styled-components';

import { Affiliation } from '@/types/affiliation';
import { AnchorLike } from '@/components/shared/AnchorLike';
import { CenteredLoader } from '@/components/utils/Loader';

type Props = {
  currentId: number;
  affiliations: Affiliation[];
  onSelect: (a: Affiliation) => void;
  logout: () => void;
  isLoading?: boolean;
};

export const OrganizationsForSelect: React.FC<Props> = (props) => {
  const { currentId, affiliations, onSelect, logout, isLoading } = props;
  const { t } = useTranslation();
  return (
    <Styled>
      <Segment className="login-box">
        <StyledHeader>{t('text.login.organizations.prompt')}</StyledHeader>
        {isLoading ? (
          <CenteredLoader />
        ) : (
          <>
            <p className="message">
              {affiliations.length === 0 ? (
                <>
                  {t('text.login.organizations.organizations_not_exist')}
                  &nbsp;
                  <AnchorLike onClick={logout}>
                    {t('ui.action.logout')}
                  </AnchorLike>
                </>
              ) : (
                t('text.login.organizations.attention')
              )}
            </p>
            <Card.Group>
              {affiliations.map((af) => (
                <Card
                  data-test={`assign-org-${af.organization.id}`}
                  key={af.organization.id}
                  className={
                    currentId === af.organization.id ? 'is-disabled' : ''
                  }
                  onClick={() => onSelect(af)}
                >
                  <Card.Content>
                    <Icon name="group" />
                    <Card.Meta className="contract-id">
                      {t('models.organization.contractId')}:
                    </Card.Meta>
                    <Card.Description>
                      {af.organization.gloplaId}
                    </Card.Description>
                  </Card.Content>
                </Card>
              ))}
            </Card.Group>
          </>
        )}
      </Segment>
    </Styled>
  );
};

const StyledHeader = styled(Header)`
  &&& {
    font-size: 1.5em;
  }
`;

const Styled = styled.div`
  .ui.segment.login-box {
    padding: 2.5em;
    font-size: 1em;
    width: 500px;
    margin: 150px auto 0;
  }
  .login-box .ui.header {
    margin: 0 0 1em !important;
  }
  i.icon {
    font-size: 1.5em;
  }
  .ui.cards .ui.card {
    width: 100%;
    &.is-disabled {
      background-color: #f8f8f9 !important;
    }
  }
  .meta,
  .description {
    position: relative;
    bottom: 2px;
    display: inline-block;
  }
  .ui.cards > .card .meta.contract-id {
    display: inline;
    margin: 0 0.5em;
    font-size: 1em;
  }
  .description {
    font-weight: bold;
  }
`;
